import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { ReportCurrencySwitch, useReportCurrency } from "./reportCurrency";
import { useMutation, useQuery } from "@apollo/client";
import { useLocation, useNavigate } from "react-router-dom";
import { siteScheduleReportMutation } from "@src/util/mutation/systemReport.mutation";
import Spinner from "@src/components/spinner";
import { CaretDownFilled } from "@ant-design/icons";
import { useSelector } from "react-redux";
import { saveAs } from 'file-saver';
import Papa from "papaparse";
import { convertToLocalTime } from "@src/util/timezone/timezoneAdjustment";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Dropdown, Input, Menu } from "antd";
import { getMobileServicesPayReporttMutation, getMobileServicesPayReportMutation } from "../../../util/mutation/systemReport.mutation";
import { GET_TENANT } from "@src/util/query/tenant.query";



// to do holiday bill and hour
// if first date is in holiday then first date hour and pay and bill will goes to holiday section and regular would be zero
// vice versa for second date as well
// Bank Holiday 65ff5efdcdef94de7cabc3cb

export const SystemReportMobileServiceBillView = () => {

    const location = useLocation();
    const {filters = {}, filterContent = '', reportDetail = {}} = location?.state || {};
    
    
    const [allReportData, setReportData] = useState([]);
    // Amounts in several currencies are shown one currency at a time, never added together
    // (see reportCurrency.jsx) — reportData is just the rows in the currency on screen.
    const reportCurrency = useReportCurrency(allReportData, { bill: (row) => row?.billCurrency });
    const reportData = reportCurrency.rows;
    const navigate = useNavigate();

    const [getMobileServicesPayReport, {loading: getMobileServicesPayReportLoading}] = useMutation(getMobileServicesPayReporttMutation);

    const handelPayBillReport = async ()=>{
        try{
            if(filters?.conditions){

                const {data:{getMobileServicesPayReport: {response}}} = await getMobileServicesPayReport({
                    variables:{
                        filters: {conditions: filters.conditions[0]!=null? filters.conditions: [], date: {
                            from: filters?.dates?.from, 
                            to: filters?.dates?.to
                        }}
                    }
                });

                
                console.log("Mobile service pay report response ", response);
                if(response?.length==0){
                    alert("There is no schedule found in the selected dates");
                    navigate(-1);
                }else{
                    setReportData(response);
                }

            }
        }catch(err){
            console.log(err);
        }
    };

    useEffect(()=>{
        if(filters){

            handelPayBillReport();

        }
    },[filters]);

    const exportToCSV = () => {
        const groupedData = groupByMultipleKeys(reportData, ["customerId", "siteGroupId", "siteId"]);
        let csvData = [];
    
        Object.keys(groupedData)?.map((customerKey) => {
            // Add customer header if grouping is enabled
            if (filters?.header?.groupbyCustomer) {
                csvData.push({
                    "Customer": customerKey?.split("_")[1]?.replaceAll("-", " "),
                    "Assignee": "",
                    "Duty Type": "",
                    "Day": "",
                    "Schedule Start": "",
                    "Schedule Finish": "",
                    "Bill": ""
                });
            }
    
            Object.keys(groupedData[customerKey])?.map((siteGroupKey) => {
                // Add site group header if grouping is enabled
                if (filters?.header?.groupbySitegroup) {
                    csvData.push({
                        "Site Group": siteGroupKey?.split("_")[1]?.replaceAll("-", " "),
                        "Assignee": "",
                        "Duty Type": "",
                        "Day": "",
                        "Schedule Start": "",
                        "Schedule Finish": "",
                        "Bill": ""
                    });
                }
    
                Object.keys(groupedData[customerKey][siteGroupKey])?.map((siteKey) => {
                    const siteJobs = groupedData[customerKey][siteGroupKey][siteKey];
                    const siteTotal = totalSite[siteKey]?.sums;
    
                    // Add site header if grouping is enabled
                    if (filters?.header?.groupbySite) {
                        csvData.push({
                            "Site": siteKey?.split("_")[1]?.replaceAll("-", " "),
                            "Assignee": "",
                            "Duty Type": "",
                            "Day": "",
                            "Schedule Start": "",
                            "Schedule Finish": "",
                            "Bill": ""
                        });
                    }
    
                    // Add address and postcode
                    csvData.push({
                        "Address": siteJobs[0]?.siteDetail?.metadata?.address || "",
                        "Assignee": "",
                        "Duty Type": "",
                        "Day": "",
                        "Schedule Start": "",
                        "Schedule Finish": "",
                        "Bill": ""
                    });
    
                    csvData.push({
                        "Post code": siteJobs[0]?.siteDetail?.postcode || "",
                        "Assignee": "",
                        "Duty Type": "",
                        "Day": "",
                        "Schedule Start": "",
                        "Schedule Finish": "",
                        "Bill": ""
                    });
    
                    // Add job records
                    siteJobs?.map((job) => {
                        csvData.push({
                            "Assignee": job?.assignee || "",
                            "Duty Type": job?.paylevelDetail?.name || "",
                            "Day": dayjs(job?.startTime).format("dddd"),
                            "Schedule Start": dayjs(job?.startTime).format("DD/MM/YYYY HH:mm"),
                            "Schedule Finish": dayjs(job?.endTime).format("DD/MM/YYYY HH:mm"),
                            "Regular Bill": `${sym}${parseFloat(job?.regularBillRate || 0).toFixed(2)}`,
                            "Bank Holiday Bill": `${sym}${parseFloat(job?.bankHolidayBillRate || 0).toFixed(2)}`
                        });
                    });
    
                    // Add site totals if grouping is enabled
                    if (filters?.header?.groupbySite) {
                        csvData.push({
                            "": "",
                            "Assignee": "",
                            "Duty Type": "",
                            "Day": "",
                            "Schedule Start": "",
                            "Site Totals": "Site Totals:",
                            "Regular Bill": `${sym}${parseFloat(siteTotal?.regularBillRate || 0).toFixed(2)}`,
                            "Bank Holiday Bill": `${sym}${parseFloat(siteTotal?.bankHolidayBillRate || 0).toFixed(2)}`
                        });
                        csvData.push({}); // Empty row for spacing
                    }
                });

                // Add site group totals if grouping is enabled
                if (filters?.header?.groupbySitegroup) {
                    const siteGroupTotal = totalSiteGroup[siteGroupKey]?.sums;
                    csvData.push({
                        "": "",
                        "Assignee": "",
                        "Duty Type": "",
                        "Day": "",
                        "Schedule Start": "",
                        "Site Group Totals": "Site Group Totals:",
                        "Regular Bill": `${sym}${parseFloat(siteGroupTotal?.regularBillRate || 0).toFixed(2)}`,
                        "Bank Holiday Bill": `${sym}${parseFloat(siteGroupTotal?.bankHolidayBillRate || 0).toFixed(2)}`
                    });
                    csvData.push({}); // Empty row for spacing
                }
            });

            // Add customer totals if grouping is enabled
            if (filters?.header?.groupbyCustomer) {
                const customerTotal = totalCustomer[customerKey]?.sums;
                csvData.push({
                    "": "",
                    "Assignee": "",
                    "Duty Type": "",
                    "Day": "",
                    "Schedule Start": "",
                    "Customer Totals": "Customer Totals:",
                    "Regular Bill": `${sym}${parseFloat(customerTotal?.regularBillRate || 0).toFixed(2)}`,
                    "Bank Holiday Bill": `${sym}${parseFloat(customerTotal?.bankHolidayBillRate || 0).toFixed(2)}`
                });
                csvData.push({}); // Empty row for spacing
            }
        });

        // Add grand totals
        csvData.push({
            "": "",
            "Assignee": "",
            "Duty Type": "",
            "Day": "",
            "Schedule Start": "",
            "Grand Totals": "Grand Totals:",
            "Regular Bill": `${sym}${parseFloat(grandTotal).toFixed(2)}`,
            "Bank Holiday Bill": `${sym}${parseFloat(grandTotalBankHoliday).toFixed(2)}`
        });
    
        const csv = Papa.unparse(csvData);
        const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
        const name = reportDetail?.name + "- " + dayjs().format("DD/MM/YYYY");
        saveAs(blob, `${name}.csv`);
    };

    const groupByMultipleKeys = (data, keys) => {
        if (!keys.length) return data; // If no keys are provided, return original data
      
        return data.reduce((acc, item) => {
          let currentLevel = acc;
      
          // Iterate through keys and build nested structure
          keys.forEach((key, index) => {

            let keyValue = "Unknown";

            if(key=="customerId"){
                keyValue = item[key]+"_"+(item?.customerDetail?.customername || "No Customer").replaceAll(" ", "-")+"_customer";
            }
            else if(key=="siteGroupId"){
                keyValue = item[key]+"_"+(item?.sitegroupsDetail?.sitegroupname || "No Site Group").replaceAll(" ", "-")+"_sitegroup";
            }
            else if(key=="siteId"){
                keyValue = item[key]+"_"+(item?.siteDetail?.sitename || "No Site").replaceAll(" ", "-")+"_site";
            }
      
            if (!currentLevel[keyValue]) {
              currentLevel[keyValue] = index === keys.length - 1 ? [] : {}; // Last level stores array, others are objects
            }
      
            // Move to the next nested level
            currentLevel = currentLevel[keyValue];
          });
      
          // Push item to the last nested level
          currentLevel.push(item);
          return acc;
        }, {});
    };

    const [groupedData, setGroupedData] = useState([]);

    const groupAndSum = (data, keys) => {
        if (!keys.length) return data; // If no keys are provided, return original data
    
        return data.reduce((acc, item) => {
            let currentLevel = acc;
    
            // Build dynamic keys for grouping
            keys.forEach((key, index) => {
                let keyValue = "Unknown";
    
                if (key === "customerId") {
                    keyValue = `${item[key]}_${(item?.customerDetail?.customername || "No Customer").replaceAll(" ", "-")}_customer`;
                } else if (key === "siteGroupId") {
                    keyValue = `${item[key]}_${(item?.sitegroupsDetail?.sitegroupname || "No Site Group").replaceAll(" ", "-")}_sitegroup`;
                } else if (key === "siteId") {
                    keyValue = `${item[key]}_${(item?.siteDetail?.sitename || "No Site").replaceAll(" ", "-")}_site`;
                }
    
                // If last level, store an array
                if (!currentLevel[keyValue]) {
                    currentLevel[keyValue] = index === keys.length - 1 ? {  sums: {} } : {};
                }
    
                // Move to the next nested level
                currentLevel = currentLevel[keyValue];
            });
    
    
            // Define properties to sum
            const sumProperties = [
                "regularBillRate",
                "bankHolidayBillRate"
            ];

            // Initialize sums object if not present
            if (Object.keys(currentLevel.sums)?.length==0) {
                currentLevel.sums = {};
                sumProperties.map(prop => currentLevel.sums[prop] = 0);


            }

            // Sum up required fields
            sumProperties.forEach(prop => {

                let value = (item?.[prop] || 0.00);

                currentLevel.sums[prop] += value;

            });

    
            return acc;
        }, {});
    };
    
    const [totalCustomer, setTotalCustomer] = useState({});
    const [totalSiteGroup, setTotalSiteGroup] = useState({});
    const [totalSite, setTotalSite] = useState({});
    const [grandTotal, setGrandTotal] = useState(0);

    useEffect(()=>{
        if(reportData){
            // ["customerId", "siteGroupId", "siteId"]
            const groupedData = groupByMultipleKeys(reportData, ["customerId", "siteGroupId", "siteId"]);
            setGroupedData(groupedData);
            setTotalCustomer( groupAndSum(reportData, ["customerId"]) );
            setTotalSiteGroup( groupAndSum(reportData, ["siteGroupId"]));
            setTotalSite( groupAndSum(reportData, ["siteId"]) );

        }
    },[reportData]);

    const [grandTotalBankHoliday, setGrandTotalBankHoliday] = useState(0);

    useEffect(()=>{
        if(totalCustomer && Object.keys(totalCustomer)?.length>0){
            let th=0;
            let thBankHoliday=0;
            Object.keys(totalCustomer)?.map((key)=>{
                th += totalCustomer[key]?.sums?.regularBillRate;
                thBankHoliday += totalCustomer[key]?.sums?.bankHolidayBillRate;
            });
            setGrandTotal(th);
            setGrandTotalBankHoliday(thBankHoliday);
        }
    },[totalCustomer]);

    

    const convertToHrsMin = (decimalHours) => {
        const hours = Math.floor(decimalHours); // Extract hours
        const minutes = Math.round((decimalHours - hours) * 60); // Convert decimal to minutes
    
        // Format hours and minutes with leading zero
        const formattedHours = String(hours).padStart(2, "0");
        const formattedMinutes = String(minutes).padStart(2, "0");
    
        return `${formattedHours} hrs ${formattedMinutes} m`;
    }
    


    const {authenticatedUserDetail} = useSelector(state=>state.userAuthReducer);


    const { data: tenantData } = useQuery(GET_TENANT, {
        variables: { tenantId: authenticatedUserDetail?.tenantId },
        fetchPolicy: 'network-only',
        skip: !authenticatedUserDetail?.tenantId
    });

    // the currency of the amounts on screen
    const sym = reportCurrency.billSymbol;

    const exportToPdf = ()=>{
        window.print();
    };

    useEffect(()=>{
        document.title = reportDetail?.name+" "+dayjs().format("DD/MM/YYYY");

        return ()=>{
            document.title = "WFC";
        }
    },[]);

    const menu = (
        <Menu >
          <Menu.Item key="1" onClick={exportToCSV}>Export CSV</Menu.Item>
          <Menu.Item key="2" onClick={exportToPdf} >Print Report</Menu.Item>
        </Menu>
    );

    return (
        <>
            <div style={{padding: "15px 30px", zoom: "1.15"}} id="pdfContent" className="siteScheduleReport">

                <ReportCurrencySwitch reportCurrency={reportCurrency} />
                <div className="reportsHeaderCss">

                    <div style={{fontWeight: "bold", fontSize: "20px", display: "flex", justifyContent: "space-between"}}>
                    <span style={{textTransform:'capitalize'}}>{reportDetail?.name}</span>
                        <div id="pdfexportBtn">

                            <Dropdown overlay={menu}>
                                <Button style={{fontSize:'12px'}}>
                                    Exports <CaretDownFilled />
                                </Button>
                            </Dropdown>





                            <div className='close-link' style={{marginRight:'-20px', fontSize:'12px'}} onClick={()=>navigate(-1)}>
                                <span >Close Report</span> <FontAwesomeIcon className='icon' icon={faTimes}/>
                            </div>

                        
                        </div>
                    </div>

                    <div className="row-flex" style={{gap: "30px", marginBottom: "6px"}}>
                        <div style={{fontWeight: "bold"}}> Report ID : {reportDetail?._id}</div>
                        <div style={{fontWeight: "bold"}}> Run Date : &nbsp;
                            <span className="text-muted" style={{fontWeight: "normal"}}>
                                {dayjs().format("DD/MM/YYYY HH:mm")} by {authenticatedUserDetail?.employeeDetail[0]?.firstname +" "+(authenticatedUserDetail?.employeeDetail[0]?.lastname || "")}
                            </span>
                        </div>
                    </div>

                    <div className="text-muted pt20">
                        <span>Date Range Report using dates between </span>
                        <span style={{padding: "0px 2px"}}>
                            {dayjs(filters?.dates?.from, "DD/MM/YYYY").format("ddd DD MMM YYYY HH:mm")}
                        </span>
                        and
                        <span style={{padding: "0px 2px"}}>
                            {dayjs(filters?.dates?.to, "DD/MM/YYYY").format("ddd DD MMM YYYY HH:mm")}
                        </span>
                    </div>

                    <div style={{display: "flex", width: "100%", marginTop: "6px"}}>
                        <div style={{width: "50px"}}>Filters :</div>
                        <div style={{width: "calc(100% - 110px)", paddingLeft: "10px", textAlign:'left', fontStyle:'oblique'}}
                            dangerouslySetInnerHTML={{__html: filterContent}}
                        >  
                        
                        </div>
                    </div>

                </div>

                <div className="mt32"></div>


                <table id="payBillPDF" className="payBillMainTable">
                    <tbody>
                        <tr className="payBillHeaderCss">
                            <th colspan="2">
                                Assignee
                            </th>
                            <th>Duty Type</th>
                            <th>Day</th>
                            <th>Schedule Start</th>
                            <th>Schedule Finish</th>
                            <th>Regular Bill</th>
                            <th>Bank Holiday Bill</th>
                        </tr>
                        
                    {
                        getMobileServicesPayReportLoading?
                            <tr>
                                <td colSpan={8} style={{textAlign: 'center'}}><Spinner /></td>
                            </tr>
                        :
                        <>


                            {Object.keys(groupedData)?.map((key)=>{
                                const customerTotal = totalCustomer[key]?.sums;


                                return(
                                    <>
                                        {
                                            filters?.header?.groupbyCustomer &&
                                            <tr className="customerCss">
                                                <td colspan="1">Customer:</td>
                                                <td colspan="3">{key?.split("_")[1]?.replaceAll("-", " ")}</td>
                                            </tr>
                                        }
                                        {
                                            // Site group rendering
                                            Object.keys(groupedData[key])?.map((secKey)=>{
                                                const siteGroupTotal = totalSiteGroup[secKey]?.sums;

                                                return(
                                                    <>
                                                    {
                                                        filters?.header?.groupbySitegroup &&
                                                        <tr className="siteGroupCss">
                                                            <td colspan="1">Site Group:  </td>
                                                            <td colspan="3">{secKey?.split("_")[1]?.replaceAll("-", " ")}</td>
                                                        </tr>
                                                    }


                                                        {/* Site rendering */}
                                                        { Object.keys(groupedData[key][secKey])?.map((tkey)=>{
                                                            const siteTotal = totalSite[tkey]?.sums;
                                                            return(
                                                            <>
                                                            {
                                                                filters?.header?.groupbySite &&

                                                                <tr className="siteCss">
                                                                    <td colspan="1">Site: </td>
                                                                    <td colspan="3">{tkey?.split("_")[1]?.replaceAll("-", " ")}</td>
                                                                </tr>

                                                            }

                                                            {

                                                                // filters?.header?.addressDetail &&
                                                                <>
                                                                <tr className="siteCss">
                                                                    <td colspan="1">Address: </td>
                                                                    <td colspan="3">{groupedData[key][secKey][tkey][0]?.siteDetail?.metadata?.address}</td>
                                                                </tr>
                                                                <tr className="siteCss">
                                                                    <td colspan="1">Post code: </td>
                                                                    <td colspan="3">{groupedData[key][secKey][tkey][0]?.siteDetail?.postcode}</td>
                                                                </tr>
                                                                </>
                                                            }
                                                                    

                                                                {/* first site record */}
                                                                <tr>
                                                                    <td colspan="8">
                                                                        <table className="payBillSitePayTable">
                                                                            <tbody>
                                                                            {
                                                                                groupedData[key][secKey][tkey]?.map((job)=>{
                                                                                    
                                                                                    return(
                                                                                
                                                                                        <tr className="siteBillCss">
                                                                                            {/* employee name */}
                                                                                            <td colspan="2">{job?.assignee}</td>
                                                                                                        
                                                                                            {/* schedule start day */}
                                                                                            <td> 
                                                                                            
                                                                                                {(job?.paylevelDetail?.name)}

                                                                                            </td>
                                                                                            
                                                                                            {/* schedule start day */}
                                                                                            <td> 
                                                                                            
                                                                                                {dayjs(job?.startTime).format("dddd")}

                                                                                            </td>
                                                                                            
                                                                                            {/* job start date and time */}
                                                                                            <td>
                                                                                                {
                                                                                                    dayjs(job?.startTime).format("DD/MM/YYYY HH:mm")
                                                                                                }
                                                                                            </td>
                                                                                            
                                                                                            {/* job end date and time */}
                                                                                            <td>
                                                                                                
                                                                                                {
                                                                                                    dayjs(job?.endTime).format("DD/MM/YYYY HH:mm")
                                                                                                    // convertToLocalTime(job?.secondDate, job?.shiftEndTime)
                                                                                                    // :
                                                                                                    // convertToLocalTime(job?.endTime , job?.shiftEndTime)
                                                                                                }
                                                

                                                                                            </td>
                                                                                            
                                                                                            {/* regular bill */}
                                                                                            <td>
                                                                                                {
                                                                                                    sym+" "+parseFloat(job?.regularBillRate || 0).toFixed(2)
                                                                                                }
                                                                                            </td>

                                                                                            {/* bank holiday bill */}
                                                                                            <td>
                                                                                                {
                                                                                                    sym+" "+parseFloat(job?.bankHolidayBillRate || 0).toFixed(2)
                                                                                                }
                                                                                            </td>
                                                                                            
                                                                                            
                                                                                        </tr>

                                                                                    )
                                                                                })
                                                                            }
                                                                            </tbody>
                                                                        </table>
                                                                    </td>
                                                                </tr>

                                                            {
                                                                
                                                                filters?.header?.groupbySite &&
                                                                <>
                                                                    <tr style={{height: "0px"}}>
                                                                        <td colspan="2"></td><td colspan="9" style={{borderBottom: "2px solid black"}}></td>
                                                                    </tr>
                                                                    

                                                                    {/* site total */}
                                                                    <tr>

                                                                        <td colspan="12">
                                                                            <table className="payBillSiteCardTable">
                                                                                <thead>
                                                                                    <tr className="titleCss">
                                                                                        <th colSpan={5}></th>
                                                                                        <th  >Site Totals:</th>
                                                                                        <th>Regular Bill</th>
                                                                                        <th>Bank Holiday Bill</th>
                                                                                    </tr>
                                                                                </thead>

                                                                                <tbody>
                                                                                    <tr className="row1">
                                                                                        <td colspan="6"></td>

                                                                                        <td>
                                                                                            {sym + (parseFloat(siteTotal?.regularBillRate || 0).toFixed(2))}
                                                                                        </td>

                                                                                        <td>
                                                                                            {sym + (parseFloat(siteTotal?.bankHolidayBillRate || 0).toFixed(2))}
                                                                                        </td>

                                                                                    </tr>
                                                                                </tbody>
                                                                            </table>
                                                                        </td>
                                                                    </tr>
                                                                </>

                                                            }

                                                            </>

                                                            )
                                                        })}


                                                        


                                                            {
                                                                
                                                                filters?.header?.groupbySite &&
                                                                <>
                                                                    <tr style={{height: "0px"}}>
                                                                        <td colspan="2"></td><td colspan="9" style={{borderBottom: "2px solid black"}}></td>
                                                                    </tr>
                                                                    

                                                                    {/* sitegroup total */}
                                                                    <tr>

                                                                        <td colspan="12">
                                                                            <table className="payBillSiteCardTable">
                                                                                <thead>
                                                                                    <tr className="titleCss">
                                                                                        <th colSpan={5}></th>
                                                                                        <th  style={{textAlign:'center'}}>Site Group Totals:</th>
                                                                                        <th>Regular Bill</th>
                                                                                        <th>Bank Holiday Bill</th>
                                                                                    </tr>
                                                                                </thead>

                                                                                <tbody>
                                                                                    <tr className="row1">
                                                                                        <td colspan="6"></td>

                                                                                        <td>
                                                                                            {sym} {(parseFloat(siteGroupTotal?.regularBillRate || 0).toFixed(2))}
                                                                                        </td>

                                                                                        <td>
                                                                                            {sym} {(parseFloat(siteGroupTotal?.bankHolidayBillRate || 0).toFixed(2))}
                                                                                        </td>

                                                                                    </tr>
                                                                                </tbody>
                                                                            </table>
                                                                        </td>
                                                                    </tr>
                                                                </>

                                                            }


                                                    </>

                                                )
                                            })
                                        }




                                        {/* customer total */}
                                        {
                                            
                                            filters?.header?.groupbyCustomer &&
                                            <>
                                                <tr style={{height: "0px"}}>
                                                    <td colspan="2"></td><td colspan="9" style={{borderBottom: "2px solid black"}}></td>
                                                </tr>
                                                

                                                <tr>

                                                    <td colspan="12">
                                                        <table className="payBillSiteCardTable">
                                                            <thead>
                                                                <tr className="titleCss">
                                                                    <th colSpan={5}></th>
                                                                    <th  style={{textAlign:'center'}}>Customer Totals:</th>
                                                                    <th>Regular Bill</th>
                                                                    <th>Bank Holiday Bill</th>
                                                                </tr>
                                                            </thead>

                                                            <tbody>
                                                                <tr className="row1">
                                                                    <td colspan="6"></td>

                                                                    <td>
                                                                        {sym+" "+(parseFloat(customerTotal?.regularBillRate || 0).toFixed(2))}
                                                                    </td>

                                                                    <td>
                                                                        {sym+" "+(parseFloat(customerTotal?.bankHolidayBillRate || 0).toFixed(2))}
                                                                    </td>

                                        
                                                                    
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </td>
                                                </tr>
                                            </>

                                        }

                                    </>
                                )
                            })}


                            {/* Grand total */}


                            
                                <>
                                    <tr style={{height: "0px"}}>
                                        <td colspan="2"></td><td colspan="9" style={{borderBottom: "2px solid black"}}></td>
                                    </tr>
                                    

                                    <tr>

                                        <td colspan="12">
                                            <table className="payBillSiteCardTable">
                                                <thead>
                                                    <tr className="titleCss">
                                                        <th colSpan={5}></th>
                                                        <th  style={{textAlign:'center'}}>Grand Totals:</th>
                                                        <th>Regular Bill</th>
                                                        <th>Bank Holiday Bill</th>
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    <tr className="row1">
                                                        <td colspan="6"></td>

                                                        <td>
                                                            {sym} {(parseFloat(grandTotal)).toFixed(2)}
                                                        </td>

                                                        <td>
                                                            {sym} {(parseFloat(grandTotalBankHoliday)).toFixed(2)}
                                                        </td>

                            
                                                        
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </td>
                                    </tr>
                                </>
                            


                        </>
                    }


                    
                    </tbody>
                </table>

            </div>

        </>
    );

};